export default "__VITE_ASSET__77d3b4b0__"